import { createSlice } from '@reduxjs/toolkit';

import { assignMetadata } from '@polyai/stream/store/utils/assign-metadata';

import { updateVoiceChannelASRSettings } from '../channels/actions';
import { updateAsrSettings } from './actions';
import { ASR_SETTINGS_SLICE_NAME } from './constants';
import type { AsrSettings, InteractionStyle } from './types';

export const DEFAULT_INTERACTION_STYLE: InteractionStyle = 'balanced';

const initialState: AsrSettings = {
  bargeIn: false,
  latencyConfig: {
    interactionStyle: DEFAULT_INTERACTION_STYLE,
  },
  updatedAt: '',
  updatedBy: '',
};

const slice = createSlice({
  name: ASR_SETTINGS_SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(updateAsrSettings, (state, action) => {
      const { latencyConfig, bargeIn } = action.payload;
      state.bargeIn = bargeIn;
      state.latencyConfig = latencyConfig;

      assignMetadata(action, state);
    });

    // Voice channel -> ASR settings sync
    builder.addCase(updateVoiceChannelASRSettings, (state, action) => {
      const { asrSettings } = action.payload;
      if (asrSettings) {
        state.bargeIn = asrSettings.bargeIn;
        state.latencyConfig = asrSettings.latencyConfig;
        assignMetadata(action, state);
      }
    });
  },
});

export default slice.reducer;
